export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SocioeconomicaPage.vue?vue&type=template&id=f551f5fa&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/SocioeconomicaPage.vue?vue&type=template&id=f551f5fa&scoped=true&
// module id = 652
// module chunks = 5